import styled from "styled-components";

export const PoolDensityWrapper = styled.div`
    background: #ffffffe3;
    z-index: 3;
    display: inline-block;
    border-radius: 4px;
    font-size: 12px;
    display: flex;
    overflow-y: scroll;
    align-items: center;
    scroll-behavior: smooth;
    transition: max-height 0.5s;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
`;
